import LinkIcon from '@mui/icons-material/Link';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import OndemandVideoOutlinedIcon from '@mui/icons-material/OndemandVideoOutlined';
import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import HtmlOutlinedIcon from '@mui/icons-material/HtmlOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import { FolderOpenOutlined, NewspaperOutlined, Payment } from '@mui/icons-material';
import { Icon } from '@sm-dashboard/ui-components';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GroupsIcon from '@mui/icons-material/Groups';
import {
  CloudQueue,
  Security,
  PhotoCamera,
  Assignment,
  DocumentScanner,
  DriveFolderUploadOutlined,
  UploadFile
} from '@mui/icons-material';
import {
  DependentOption,
  FormResultsStatuses,
  Page,
  PERSONAL_PAGE_FAMILY_LABELS,
  PredefinedSection
} from '@sm-dashboard/types';
import { ChipProps } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import { Ai } from '@/assets/icons/Ai';
import CelebrationIcon from '@mui/icons-material/Celebration';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { theme } from './theme/theme';
import PeopleIcon from '@mui/icons-material/People'; // שלוחים
import BusinessIcon from '@mui/icons-material/Business'; // סניפים
import RestaurantIcon from '@mui/icons-material/Restaurant'; // סעודות שבת
import LocalOfferIcon from '@mui/icons-material/LocalOffer'; // תגיות
import EventIcon from '@mui/icons-material/Event';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { getUrls } from './util/urls';
import { ISRAEL_REGULATIONS_ROUTE, WORLD_REGULATIONS_ROUTE } from './util/regulationsRoute';

//auth Urls
export const loginUrl = `pvt/auth/login`;
export const loginMfaUrl = `pvt/auth/login-mfa`;
export const resendMfa = `pvt/auth/re-send-mfa`;
export const verifyPhoneUrl = `pvt/auth/verify-phone`;
export const registerMfaUrl = `pvt/auth/register-mfa`;
export const registerMfaWorldUrl = `pvt/auth/register-mfa-world`;
export const registerShaliachMfaUrl = `pvt/auth/register-shaliach-mfa`;
export const registerCandidateUrl = `pvt/auth/register-candidate`;
export const googleLoginUrl = 'pvt/auth/google-login';
export const googleOAuthCallbackUrl = 'pvt/auth/google-oauth-callback';
export const refreshGoogleTokenUrl = 'pvt/auth/refresh-google-token';
export const requestSensitiveCodeUrl = 'pvt/auth/request-sensitive-code';
export const verifySensitiveCodeUrl = 'pvt/auth/verify-sensitive-code';

//report Urls
export const reportUrl = `pub/report`;

//count Urls
export const shluchimCountUrl = `pvt/shluchim/count`;
export const branchsCountUrl = `pvt/branchs/count`;
export const branchsByShluchimCountUrl = `pvt/branchs/branchs-by-shluchim-count`;

//map
export const layersUrl = 'pvt/layers';
export const branchDetailsUrl = 'pvt/branchs/branchs-with-shluchim-details';
export const branchLatlngUrl = 'pvt/branchs/branch-latlng';
export const shluchimBookQueryParam = 'forShluchimBook=true';
export const getBranchDetailsForShluchimBookUrl = (branchId: string | number) =>
  `${branchDetailsUrl}/${branchId}?${shluchimBookQueryParam}`;

//all
export const shluchimAllUrl = `pvt/shluchim/all`;
export const shluchimBookAllUrl = `${shluchimAllUrl}?${shluchimBookQueryParam}`;
export const shluchimAllBasicUrl = `pvt/shluchim/all-basic`;
export const shluchimAllPubUrl = `pub/shluchim/all`;
export const branchsAllUrl = `pvt/branchs/all`;
export const branchsGroupForFiltersUrl = 'pvt/branchs/group-for-filters';

export const editGeomUrl = 'pvt/branchs/edit-geom-request';
export const branchsPolygonAndCenterUrl = `pvt/branchs/branchs-polygon-center-lat-lng`;

//branchs
export const updateBranchUrl = 'pvt/branchs/update-branch-details';
export const branchSmsNameUrl = 'pvt/branchs/sms-name';
export const getBranchByIdUrl = 'pvt/branchs/branchs-by-id';
export const createBranchUrl = 'pvt/branchs/create-new-branch';
export const deleteBranchUrl = 'pvt/branchs/delete-branch';

//shluchim
export const shluchimGroupForFiltersUrl = 'pvt/shluchim/group-for-filters';
export const shluchimAllWithDetailsUrl = `pvt/shluchim/all-shluchim-with-details`;
export const shluchimProfileCompletenessUrl = `pvt/shluchim/profile-completeness`;
export const updateShluchimUrl = 'pvt/shluchim/update-shaliach-details';
export const getShluchimByIdUrl = 'pvt/shluchim/shaliach-by-id';
export const addShluchimUrl = 'pvt/shluchim/add-shaliach';
export const shluchimGoogleStatusUrl = 'pvt/shluchim/google-status';
export const shluchimGoogleAuthUrl = 'pvt/auth/google-auth-url';
export const deleteShaliachUrl = 'pvt/shluchim/delete-shaliach';

// Internal tags (admin-only)
export const internalTagsUrl = 'pvt/internal-tags';

// Generic mailing URLs
export const mailingSmsUrl = 'pvt/mailing/sms';
export const mailingEmailUrl = 'pvt/mailing/email';
export const mailingWhatsAppUrl = 'pvt/mailing/whatsapp';
export const mailingAppUrl = 'pvt/mailing/app';
export const mailingHistoryUrl = 'pvt/mailing/history';
export const gridExportEmailUrl = 'pvt/grid-export/email';

//leads
export const leadsUrl = 'pvt/leads/leads-by-id';
export const leadsAnalyticsUrl = 'pvt/leads/analytics';
export const leadsGroupForFiltersUrl = 'pvt/leads/group-for-filters';
export const updateLeadsByIdUrl = 'pvt/leads/update-by-id';
export const deleteLeadsByIdUrl = 'pvt/leads/delete-by-id';
export const bulkDeleteLeadsUrl = 'pvt/leads/bulk-delete';
export const bulkMoveLeadsUrl = 'pvt/leads/bulk-move';
export const isNewLeadsCountUrl = 'pvt/leads/is-new-leads-count';

//Donations
export const donationsRoute = '/desk/donations';
export const donorsRoute = '/desk/donations/donors';
export const incomesRoute = '/desk/incomes';
export const incomesDashboardRoute = '/desk/incomes-dashboard';
export const standingOrdersRoute = '/desk/standing-orders';
export const donationsUrl = 'pvt/donations/donations-by-id';
export const donationsGroupForFiltersUrl = 'pvt/donations/group-for-filters';
export const updateDonationsByIdUrl = 'pvt/donations/update-by-id';
export const deleteDonationsByIdUrl = 'pvt/donations/delete-by-id';
export const bulkCreditDonationsUrl = 'pvt/donations/bulk-credit';
export const bulkMoveDonationsUrl = 'pvt/donations/bulk-move';
export const bulkCampaignVisibilityUrl = 'pvt/donations/bulk-campaign-visibility';
export const updateDonationCommentUrl = 'pvt/donations/update-comment';
export const updateDonationsGroupUrl = 'pvt/donations/update-group';
export const donationsAnalyticsUrl = 'pvt/donations/analytics';
export const createManualDonationUrl = 'pvt/donations/create-manual';
export const updateManualDonationUrl = 'pvt/donations/update-manual';
export const donationsImportTemplateUrl = 'pvt/donations/import/template';
export const donationsImportUploadUrl = 'pvt/donations/import/upload';
export const donorsUrl = 'pvt/donations/donors';
export const donationsByPhoneUrl = 'pvt/donations/donors/donations';
export const donationsByPersonalPageIdUrl = 'pub/donations/by-personal-page-id';
export const publicDonationsUrl = 'pub/donations'; // /:id

//orders
export const ordersUrl = 'pvt/orders/orders-by-id';
export const ordersGroupForFiltersUrl = 'pvt/orders/group-for-filters';
export const updateOrdersByIdUrl = 'pvt/orders/update-by-id';
export const addOrdersByIdUrl = 'pvt/orders/add-order';
export const deleteOrdersByIdUrl = 'pvt/orders/delete-by-id';

//Contacts
export const contactsUrl = 'pvt/contacts/contacts-by-id';
export const contactsGroupForFiltersUrl = 'pvt/contacts/group-for-filters';

//Purchases
export const purchasesRoute = '/desk/purchases';
export const purchasesUrl = 'pvt/purchases/purchases-by-id';
export const purchasesGroupForFiltersUrl = 'pvt/purchases/group-for-filters';
export const updatePurchasesByIdUrl = 'pvt/purchases/update-by-id';
export const purchasesAnalyticsUrl = 'pvt/purchases/analytics';
export const deletePurchasesByIdUrl = 'pvt/purchases/delete-by-id';
export const bulkCreditPurchasesUrl = 'pvt/purchases/bulk-credit';

//Finance
export const monthlyFinanceSummaryUrl = 'pvt/finance/monthly-summary';
export const financeDashboardCardsUrl = 'pvt/finance/dashboard-cards';
export const monthlyFinanceUpdateStatusUrl = 'pvt/finance/monthly-summary/update-status';
export const paymentRequestDocumentsUrl = 'pvt/finance/payment-request-documents';
export const financeShluchimForFiltersUrl = 'pvt/finance/shluchim-for-filters';
export const financeAmutaCreditShluchimUrl = 'pvt/finance/amuta-credit-shluchim';
export const financeAmutaPaymentDocsHistoryUrl = 'pvt/finance/amuta-payment-docs-history';
export const incomesUrl = 'pvt/incomes';
export const incomesAnalyticsUrl = 'pvt/incomes/analytics';
export const standingOrdersUrl = 'pvt/incomes/standing-orders';
export const standingOrdersAnalyticsUrl = 'pvt/incomes/standing-orders/analytics';
export const updateStandingOrderUrl = (id: number) => `pvt/incomes/standing-orders/${id}`;
export const cancelStandingOrderUrl = (id: number) => `pvt/incomes/standing-orders/${id}/cancel`;
export const donationRefundRequestsUrl = 'pvt/donation-refund-requests';
export const donationRefundTermsUrl = '';
export const paymentRequestSamplePdfUrl = '/docs/amuta-payment-request-sample.pdf';

//Events = My-Centers
export const eventsConfigurationUrl = 'pvt/events/configuration';
export const updateEventsConfigurationUrl = (id: number) => `pvt/events/configuration/${id}`;
export const reorderEventsConfigurationUrl = 'pvt/events/configuration/reorder';
export const eventsByIdUrl = 'pvt/events/event-by-id';
export const allEventsByShaliachIdUrl = 'pvt/events/all-events-by-shaliach-id';
export const activeEventsByShaliachIdUrl = 'pvt/events/active-events-by-shaliach-id';
export const addEventUrl = 'pvt/events/add-event';
export const updateEventUrl = 'pvt/events/update-event';
export const deleteEventUrl = 'pvt/events/delete-event';
export const eventsGroupForFiltersUrl = 'pvt/events/group-for-filters';
export const getPersonalEventsGroupForFilters = 'pvt/personal-pages/group-for-filters';

//Operations to
export const forwardOperationToShaliachUrl = 'pvt/shluchim/forward-operations-to-shaliach';
export const deleteOperationToShaliachUrl = 'pvt/shluchim/delete-operation-to-shaliach';
export const allOperationsToShaliachUrl = 'pvt/shluchim/all-operations-to-shaliach';
export const allLadsOperationsUrl = 'pvt/shluchim/all-leads-operations';

//Stam
export const stamOrdersByIdUrl = 'pvt/stam/orders-by-id';
export const stamUpdateCheckUrl = 'pvt/stam/update-check';
export const stamCreateOrderUrl = 'pvt/stam/create-order';
export const stamDeleteCheckUrl = 'pvt/stam/delete-check';
export const stamDeleteOrderUrl = 'pvt/stam/delete-order';
export const stamGroupForFiltersUrl = 'pvt/stam/group-for-filters';

//Feed
export const addPostUrl = 'pvt/feed/add-post';
export const deletePostUrl = 'pvt/feed';
export const updatePostUrl = 'pvt/feed';
export const getPostsUrl = 'pvt/feed';
export const likeOrLikePostUrl = 'pvt/feed/like';
export const addCommentUrl = 'pvt/feed/add-comment';
export const getCommentsUrl = 'pvt/feed/get-comments';
export const updateCommentUrl = 'pvt/feed/update-comment';
export const deleteCommentUrl = 'pvt/feed/delete-comment';
export const feedBannersUrl = 'pvt/feed/banners';

//Archive
export const archiveUrl = 'pvt/archive';
export const archiveAllUrl = 'pvt/archive/all';
export const archiveAddUrl = 'pvt/archive/add-archive-meta';
export const archiveDeleteUrl = 'pvt/archive';
export const archiveUpdateUrl = 'pvt/archive/update-archive-meta';
export const archiveUploadCoverUrl = 'pvt/archive/upload-cover';
export const resortingUpdateUrl = 'pvt/archive/resorting-archive-meta';
export const archiveSortingUpdateUrl = 'pvt/archive/sorting';
export const getArchiveMetaBreadcrumbsUrl = 'pvt/archive/breadcrumbs';
export const archiveCloneFoldersUrl = 'pvt/archive/clone-folders';

export const archiveDataUrl = 'pvt/archive/data';
export const kedmaHomeUrl = 'pvt/archive/data/kedma-home';
export const kedmaHomePicksUrl = 'pvt/archive/data/kedma-picks';
export const getArchiveDataByIdUrl = 'pvt/archive/data'; // /:id
export const archiveDataUploadUrl = 'pvt/archive/add-data-file';
export const archiveDataAddUrl = 'pvt/archive/data/add-archive-data';
export const archiveDataUpdateUrl = 'pvt/archive/data/update-archive-data';
export const archiveDataSendWaUrl = 'pvt/archive/data/send-wa';
export const archiveDataSortingUpdateUrl = 'pvt/archive/data/sorting';
export const archiveDataPermissionsUrl = 'pvt/archive/data/update-tags-allow';
export const archiveDataAllUrl = 'pvt/archive/data/all-data';
export const kedmaGroupForFiltersUrl = 'pvt/archive/data/group-for-filters';
export const archiveDownloadImageUrl = 'pvt/archive/data/download-image';

//AI image
export const aiImageEditUrl = 'pvt/ai/image/edit';
export const aiImageGenerateUrl = 'pvt/ai/image/generate';
export const aiUsageUrl = 'pvt/ai/usage';
export const aiExtractEventUrl = 'pvt/ai/extract-event';
export const aiChatUrl = 'pvt/ai/chat';
export const aiChatActionUrl = 'pvt/ai/chat/action';

//Assets
export const assetsUrl = 'pvt/assets';
export const assetsAddUrl = 'pvt/assets/add-asset';
export const assetsDeleteUrl = 'pvt/assets';
export const assetsUpdateUrl = 'pvt/assets/update-asset';

//Campaigns = Personal Links
export const campaignsUrl = 'pvt/campaigns';
export const linkPreviewUrl = 'pvt/campaigns/link-preview';
export const getPersonalLinksUrl = 'pvt/campaigns/get-personal-links';
export const saveCustomLinkUrl = 'pvt/campaigns/save-custom-link';
export const deletePersonalLinkUrl = 'pvt/campaigns/del-personal-link';
export const backfillThumbnailsUrl = 'pvt/campaigns/backfill-thumbnails';
export const updateCampaignsSortingUrl = 'pvt/campaigns/sorting';
export const updatePersonalLinksSortingUrl = 'pvt/campaigns/personal-links/sorting';
// export const getPersonalCampaignsUrl = 'pvt/campaigns/get-personal-pages';
// export const postPersonalCampaignsUrl = 'pvt/campaigns/post-personal-page';
// export const deletePersonalCampaignUrl = 'pvt/campaigns/del-personal-page';
// export const updatePersonalCampaignUrl = 'pvt/campaigns/update-personal-page';

//Personal Pages
export const getPersonalPagesUrl = 'pvt/personal-pages';
export const getPPagesAdminSummaryUrl = 'pvt/personal-pages/admin-summary';
export const postPersonalPageUrl = 'pvt/personal-pages';
export const updatePersonalPageUrl = 'pvt/personal-pages';
export const deletePersonalPageUrl = 'pvt/personal-pages';
export const publishPersonalPageUrl = 'pvt/personal-pages/publish';
export const publicPersonalPagesCreateDonationUrl = 'pub/pages/payment';

export const donationsArchiveRoute = '/outreach/donations-archive';
export const informationPagesArchiveRoute = '/outreach/information-pages-archive';
export const personalDonationOrderRoute = '/campaign-donation';
export const personalInformationPageOrderRoute = '/info-page';
export const personalEventOrderRoute = '/event/order';

const shareOrigin = getUrls().frontendExternalUrl;

export const personalDonationUrlBase = `${shareOrigin}${personalDonationOrderRoute}`;
export const personalInformationPageUrlBase = `${shareOrigin}${personalInformationPageOrderRoute}`;
export const personalEventUrlBase = `${shareOrigin}${personalEventOrderRoute}`;

//Tags
export const tagsUrl = 'pvt/tags';
export const addTagUrl = 'pvt/tags/addtag';
export const getTagsUrl = 'pvt/tags/distinct';
export const getTagsWithUsersCountsUrl = 'pvt/tags/distinct?withCounts=true';
export const tagCategoriesUrl = 'pvt/tags/categories';

//FormsCreation
export const formsUrl = 'pvt/forms';
export const submitFormUrl = 'pvt/forms/submit-form';
export const updateFormUrl = 'pvt/forms/update-form';
export const deleteFormUrl = 'pvt/forms/delete-form';
export const duplicateFormUrl = 'pvt/forms/duplicate-form';

export const formsGroupForFiltersUrl = 'pvt/forms/group-for-filters';
export const personalPageTemplatesUrl = 'pvt/forms/personal-page-templates';

//Public Forms
export const publicFormsUrl = 'pub/forms';
export const publicFormsResultsUrl = 'pub/forms-results';
export const publicVerifyFormPaymentUrl = 'pub/forms-results/verify-payment';
export const createPaymentSessionUrl = 'pub/payment/createPayment';
export const verifyPaymentUrl = 'pub/payment/verify';
export const paymentStatusUrl = 'pub/payment/status';

//FormResults
export const submitFormResultUrl = 'pvt/form-results/submit-form-result';
export const getFormResultsUrl = 'pvt/form-results';
export const getFormResultByIdUrl = 'pvt/form-results';
export const updateManyFormResultsUrl = 'pvt/form-results/update-form-results';
export const updateFormResultUrl = 'pvt/form-results/update-form-result';
export const deleteFormResultUrl = 'pvt/form-results/delete-form-result';
export const deleteManyFormResultsUrl = 'pvt/form-results/delete-form-results';
export const formResultsGroupForFiltersUrl = 'pvt/form-results/group-for-filters';
export const getRandomApprovedFormResultsUrl = 'pvt/form-results/random-approved';
export const getRandomApprovedMultipleFormResultsUrl = 'pvt/form-results/random-approved-multiple';
export const verifyFormPaymentUrl = 'pvt/form-results/verify-payment';

//CRM
export const crmContactsUrl = 'pvt/crm/contacts';
export const crmAllContactsUrl = 'pvt/crm/contacts/all';
export const crmHeatmapUrl = 'pvt/crm/contacts/heatmap';
export const crmHebrewCalendarUrl = 'pvt/crm/contacts/hebrew-calendar';
export const crmSyncGoogleContactsUrl = 'pvt/crm/sync-google-contacts';
export const crmSyncStatusUrl = 'pvt/crm/sync-status';
export const crmCancelSyncUrl = 'pvt/crm/cancel-sync';
export const crmImportFromSourcesUrl = 'pvt/crm/import-from-sources';
export const crmCustomFieldsUrl = 'pvt/crm/custom-fields';
export const crmTemplatesUrl = 'pvt/crm/templates';
export const operationsUrl = 'pvt/operations';
export const crmCategoryOperationsUrl = 'pvt/category-operations';
export const crmActivitiesUrl = 'pvt/crm/activities';
export const crmGroupActivitiesUrl = 'pvt/crm/group-activities';
export const crmGroupsUrl = 'pvt/crm/groups';
export const crmCommitmentsUrl = 'pvt/crm/commitments';
export const crmContactFormUrl = 'pvt/crm/contact-form';
export const publicCrmContactFormUrl = 'pub/crm-contact-form';
export const shaliachActivitiesUrl = 'pvt/shluchim/activities';
export const getShaliachActivitiesGroupForFilters = 'pvt/shluchim/activities/group-for-filters';
export const crmValidateGoogleTokensUrl = 'pvt/crm/validate-google-tokens';
export const crmTagCountsUrl = 'pvt/crm/contacts/tag-counts';
export const crmRebbeReportUrl = 'pvt/crm/rebbe-report';

//SMS
export const smsHistoryUrl = 'pvt/crm/contacts/sms-history';
export const crmSendSmsToContactsUrl = 'pvt/crm/contacts/send-sms';

//Email
export const emailHistoryUrl = 'pvt/crm/contacts/email-history';

//Email
export const sendEmailUrl = 'pvt/crm/contacts/send-email';

//Favorites
export const addFavoriteUrl = 'pvt/favorites';
export const removeFavoriteUrl = 'pvt/favorites';
export const checkUserFavoriteUrl = 'pvt/favorites/check';
export const getUserFavoritesUrl = 'pvt/favorites';
export const checkMultipleFavoritesUrl = 'pvt/favorites/check-multiple';

//Ratings
export const addOrUpdateRatingUrl = 'pvt/ratings';
export const getUserRatingUrl = 'pvt/ratings/user';
export const getAdAverageRatingUrl = 'pvt/ratings/average';
export const getMultipleAdsAverageRatingsUrl = 'pvt/ratings/averages';

//Ad Comments
export const addAdCommentUrl = 'pvt/comments';
export const getAdCommentsUrl = 'pvt/comments';
export const updateAdCommentUrl = 'pvt/comments';
export const deleteAdCommentUrl = 'pvt/comments';
export const getAdCommentsCountUrl = 'pvt/comments/count';
export const getMultipleAdsCommentsCountsUrl = 'pvt/comments/counts';

//Business Ads
export const businessAdsUrl = 'pvt/business-ads';
export const businessAdsMineUrl = 'pvt/business-ads/mine';
export const businessAdsAdminUrl = 'pvt/business-ads/admin';
export const deleteBusinessAdUrl = 'pvt/business-ads/admin';
export const businessAdsUploadUrl = 'pvt/business-ads/upload';
export const publicBusinessAdsUrl = 'pub/business-ads';
export const publicBusinessAdsUploadUrl = 'pub/business-ads/upload';

//Departments
export const departmentsUrl = 'pvt/departments';
export const addDepartmentUrl = 'pvt/departments/add-department';
export const updateDepartmentUrl = 'pvt/departments/update-department';
export const deleteDepartmentUrl = 'pvt/departments/delete-department';

//PredefinedSections
export const predefinedSectionsUrl = 'pvt/predefined-sections';

//Tickets
export const ticketsUrl = 'pvt/tickets';
export const ticketsInfoUrl = 'pvt/tickets-info';
export const getTicketsInfoByEventIdUrl = 'pvt/tickets-info/event';
export const getTicketsInfoByPersonalEventsUrl = 'pvt/tickets-info/personal-events';
export const personalEventTicketsAnalyticsUrl = 'pvt/tickets-info/personal-events/analytics';
export const bulkCreditTicketsInfoUrl = 'pvt/tickets-info/bulk-credit';
export const createManualEventRegistrationUrl = 'pvt/tickets-info/create-manual';
export const resendTicketsInfoUrl = 'pvt/tickets-info/resend';
export const updateTicketsInfoUrl = 'pvt/tickets-info';
export const deleteTicketsInfoUrl = 'pvt/tickets-info';

//Archive Favorites
export const addArchiveFavoriteUrl = 'pvt/archive/favorites';
export const removeArchiveFavoriteUrl = 'pvt/archive/favorites';
export const getUserArchiveFavoritesUrl = 'pvt/archive/favorites/user';

//
export const homeShaliachDashboardUrl = 'pvt/home';

//Bucket
export const uploadFileUrl = 'pvt/bucket/upload-file-to-cloud-storage';
export const uploadFileWithThumbnailUrl = 'pvt/bucket/upload-file-with-thumbnail-to-cloud-storage';
export const uploadOgThumbnailUrl = 'pvt/bucket/upload-og-thumbnail';
export const getImageAsBase64Url = 'pvt/bucket/get-image-as-base64';

//PageHelp
export const pageHelpUrl = 'pvt/page-help';
export const pageHelpAllUrl = 'pvt/page-help/all';

//Payment
export const paymentsInstructionsUrl = 'pvt/payments/all';
export const paymentsGroupForFiltersUrl = 'pvt/payments/group-for-filters';
export const deletePaymentsUrl = 'pvt/payments/delete';
export const updateRecurringUrl = 'pvt/payments/recurring'; // PUT /:id
export const retryChargeUrl = 'pvt/payments/retry-charge'; // POST /:id

export const subscriptionPlansPrivateUrl = 'pvt/subscription-plans';
export const subscriptionPlanCategoriesUrl = 'pvt/subscription-plan-categories';
export const subscriptionInstancesPrivateUrl = 'pvt/subscriptions';

// Payment Providers
export const paymentProviderUrl = 'pvt/shluchim/payment-provider'; // /payment-provider/:shaliachId
export const paymentProvidersUrl = 'pvt/shluchim/payment-providers'; // /payment-providers/:shaliachId
export const createTestPaymentUrl = 'pub/payment/test-shaliach-payment'; // /:shaliachId

// Event Registration API URLs
export const createTicketInfoUrl = 'pub/tickets-info';
export const getTicketsInfoByIdPublicUrl = 'pub/tickets-info';
export const createTicketPurchaseUrl = 'pub/tickets-info/purchase';
export const getTicketByTokenUrl = 'pub/tickets-info/display'; // /:ticketToken
export const completeTicketPurchaseUrl = 'pub/tickets-info/verify-payment';
export const getEventByIdUrl = 'pub/pages/event'; // /:id (UUID)
export const getTicketsForEventUrl = 'pub/tickets';

//AI
export const streamMessageUrl = 'pvt/ai/stream';

export const regulationsUrl = 'pvt/regulations';

//Centers
export const centersUrl = 'pub/centers';
export const shluchimUrl = 'pub/centers/shluchim';
export const countriesUrl = 'pub/centers/countries';
export const citiesUrl = 'pub/centers/cities';

//WhatsApp
export const whatsappStatusUrl = 'pvt/whatsapp/status';
export const whatsappConnectUrl = 'pvt/whatsapp/connect';
export const whatsappDeleteSessionUrl = 'pvt/whatsapp/delete';
export const whatsappStopSessionUrl = 'pvt/whatsapp/stop';
export const whatsappStartSessionUrl = 'pvt/whatsapp/start';
export const whatsappRestartSessionUrl = 'pvt/whatsapp/restart';
export const whatsappLogoutSessionUrl = 'pvt/whatsapp/logout';
export const whatsappQrCodeUrl = 'pvt/whatsapp/qr-code';
export const whatsappRequestCodeUrl = 'pvt/whatsapp/request-code';
export const whatsappUpdateSessionEnabledOrDisabledWebhookUrl =
  'pvt/whatsapp/update-session-enabled-or-disabled-webhook';

//Tasks
export const tasksUrl = 'pvt/tasks';
export const createTaskUrl = 'pvt/tasks';
export const updateTaskUrl = 'pvt/tasks/update';
export const deleteTaskUrl = 'pvt/tasks/delete';
// Events urls
export const eventsArchiveRoute = '/outreach/events-archive';
export const myPageRoute = '/outreach/my-page';
export const eventCreationRoute = '/outreach/event-creation';
export const personalEventPaymentRoute = '/event/payment';
export const personalEventSuccessRoute = '/event/success';
export const registerationsRoute = '/desk/registerations';

// Shabbat meals management area (ניהול סעודות שבת)
export const shabbatMealsUrl = 'pvt/shabbat-meals';
export const shabbatMealsRoute = '/org/shabbat-meals';
/** Public sale page of a shabbat-meals series (one page per series, all upcoming dates). */
export const shabbatMealsSeriesPublicUrl = (seriesId: number) => `${shareOrigin}/shabbat-meals/series/${seriesId}`;
export const campaignCreationRoute = '/outreach/campaign-creation';
export const personalDonationRoute = '/outreach/personal-donation';
/** Archive template identifiers for the personal-donation sidebar entry (דפים אישיים). */
export const PERSONAL_DONATION_SIDEBAR_ARCHIVE = {
  name: 'דף התרמה כללי',
  personalPageType: 'openDonation',
  link: '9bc20491-661b-420e-98b2-daae61d4493b'
} as const;

export const personalDonationSidebarLink = (() => {
  const params = new URLSearchParams({
    name: PERSONAL_DONATION_SIDEBAR_ARCHIVE.name,
    personalPageType: PERSONAL_DONATION_SIDEBAR_ARCHIVE.personalPageType,
    link: PERSONAL_DONATION_SIDEBAR_ARCHIVE.link
  });
  return `${personalDonationRoute}?${params.toString()}`;
})();

export const informationPageCreationRoute = '/outreach/information-page-creation';
/** @deprecated Use informationPageCreationRoute — all information-family subtypes share one wizard */
export const registrationCreationRoute = informationPageCreationRoute;

export const CRM_BASE = 'pvt/crm';

export const canvaColor = '#00C4CC';

export const worldShalich = 'שליח חו״ל';
export const worldShalicha = 'שליחה חו״ל';
export const worldCommunityTag = 'קהילה חו״ל';
export const publicUserType = 'משתמש ציבורי';
export const publicAdminUserType = 'מנהלה';
export const DEFAULT_REGISTRATION_BRANCH_ID = 999;
export const WORLD_SHALICH_TAGS = [worldShalich, worldShalicha] as const;

export const isWorldShalichUser = (permission?: { hasTag: (tag: string) => boolean } | null) =>
  WORLD_SHALICH_TAGS.some(tag => permission?.hasTag(tag));

/** Friends of Chabad Worldwide — shluchim. Same string as the backend tag. */
export const worldFriendsShluchimTag = 'ידידי חב״ד בעולם - שלוחים';

export const shouldHideDonationFees = (permission?: { hasTag: (tag: string) => boolean } | null) =>
  isWorldShalichUser(permission) || Boolean(permission?.hasTag(worldFriendsShluchimTag));

export const isWorldShalichRole = (role?: string | null) =>
  !!role && WORLD_SHALICH_TAGS.includes(role as (typeof WORLD_SHALICH_TAGS)[number]);

export const pagesList: Page[] = [
  {
    primary: 'הדסק',
    mobileMenuSubtitle: 'כל הפניות, ההרשמות והפעילות הנכנסת',
    icon: <Icon icon="desk" color="primary.main" size="medium" />,
    children: [
      {
        primary: 'פניות',
        icon: <Icon icon="envelope" color="primary.main" size="medium" />,
        link: '/desk/leads',
        isMobilePrimary: true
      },
      {
        primary: 'תרומות',
        icon: <Icon icon="donation" color="primary.main" size="medium" />,
        link: donationsRoute,
        isMobilePrimary: true
      },
      { primary: 'מכירות', icon: <Icon icon="cart" color="primary.main" size="medium" />, link: purchasesRoute },
      {
        primary: 'הרשמות וכרטיסים',
        icon: <Icon icon="ticket" color="primary.main" size="medium" />,
        link: registerationsRoute
      },
      { primary: 'סעודות שבת', icon: <RestaurantIcon />, link: shabbatMealsRoute },
      { isFinanceHeader: true, primary: 'כספים' },
      {
        primary: 'מבט על',
        icon: <Icon icon="dashboardOutlined" color="primary.main" size="medium" />,
        link: incomesDashboardRoute
      },
      {
        primary: 'הכנסות',
        icon: <Icon icon="tableChartOutlined" color="primary.main" size="medium" />,
        link: incomesRoute
      },
      {
        primary: 'הוראות קבע',
        icon: <Icon icon="history" color="primary.main" size="medium" />,
        link: standingOrdersRoute
      }
    ]
  },
  {
    primary: 'חוצה',
    mobileMenuSubtitle: 'הפרסומים, ההתרמות, האירועים והפעילויות היוצאות',
    icon: <Icon icon="globe" color="primary.main" size="medium" />,
    children: [
      { isHeader: true, primary: 'חוצה' },
      {
        primary: 'כרטיס ביקור',
        icon: <Icon icon="identityCard" color="primary.main" size="medium" />,
        link: '/outreach/personal-card'
      },
      { primary: 'הדף שלי', icon: <Icon icon="browser" color="primary.main" size="medium" />, link: myPageRoute },
      {
        primary: 'האתר שלי',
        icon: <Icon icon="browser" color="primary.main" size="medium" />,
        link: '/outreach/my-website'
      },
      {
        primary: 'קישורים אישיים',
        icon: <Icon icon="attachment" color="primary.main" size="medium" />,
        link: '/outreach/personal-links'
      },
      {
        primary: 'המוקדים שלי',
        icon: <Icon icon="location" color="primary.main" size="medium" />,
        link: '/outreach/my-centers'
      },
      { isKedmaHeader: true, primary: 'קדמה' },
      {
        primary: 'פרסומים להפצה',
        icon: <Icon icon="browser" color="primary.main" size="medium" />,
        link: '/outreach/press-wa'
      },
      {
        primary: 'עיצובים',
        mobilePrimaryLabel: 'קדמה',
        icon: <Icon icon="kedma" color="primary.main" size="medium" />,
        link: '/outreach/kedma',
        isMobilePrimary: true
      },
      { isPersonalHeader: true, primary: 'דפים אישיים' },
      {
        primary: PERSONAL_PAGE_FAMILY_LABELS.information.plural,
        icon: <Icon icon="form" color="primary.main" size="medium" />,
        link: '/outreach/information-pages-archive'
      },
      {
        primary: PERSONAL_PAGE_FAMILY_LABELS.campaign.plural,
        icon: <Icon icon="tableHeart" color="primary.main" size="medium" />,
        link: '/outreach/donations-archive'
      },
      {
        primary: 'דף התרמה כללי',
        icon: <Icon icon="tableHeart" color="primary.main" size="medium" />,
        link: personalDonationSidebarLink
      },
      {
        primary: PERSONAL_PAGE_FAMILY_LABELS.event.plural,
        icon: <Icon icon="calendar" color="primary.main" size="medium" />,
        link: '/outreach/events-archive'
      }
    ]
  },
  {
    primary: 'אנשים',
    mobileMenuSubtitle: 'אנשי קשר, התחייבויות והטפסים שלי',
    icon: <Icon icon="people" color="primary.main" size="medium" />,
    link: '/crm',
    children: [
      {
        primary: 'לוח בקרה',
        icon: <Icon icon="monitor" color="primary.main" size="medium" />,
        link: '/crm/dashboard'
      },
      {
        primary: 'אנשי קשר',
        icon: <Icon icon="contacts" color="primary.main" size="medium" />,
        link: '/crm/contacts'
      },
      {
        primary: 'דיוור',
        icon: <Icon icon="sent" color="primary.main" size="medium" />,
        link: '/crm/mailing'
      },
      {
        primary: 'התחייבויות',
        icon: <Icon icon="receipt" color="primary.main" size="medium" />,
        link: '/crm/commitments'
      },
      {
        primary: 'הטפסים שלי',
        icon: <Icon icon="forms" color="primary.main" size="medium" />,
        link: '/crm/forms/user-forms'
      },
      {
        primary: 'בוט ווטצאפ',
        icon: <Icon icon="robot" color="primary.main" size="medium" />,
        link: '/crm/whatsapp-bot'
      },
      {
        primary: 'דוח לרבי',
        icon: <Icon icon="letter" color="primary.main" size="medium" />,
        link: '/crm/rebbe-report'
      }
    ]
  },
  {
    primary: 'ארגוני ',
    mobileMenuSubtitle: 'מה חדש, קישורים שימושיים, טפסים ושאלונים',
    icon: <Icon icon="organization" color="primary.main" size="medium" />,
    children: [
      {
        primary: 'מה חדש?',
        icon: <Icon icon="contactsBook" color="primary.main" size="medium" />,
        link: '/org/feed',
        isMobilePrimary: true
      },
      {
        primary: 'חב"ד בפריים',
        icon: <PhotoCamera />,
        link: '/org/archive-gallery'
      },
      {
        primary: 'קישורים שימושיים',
        icon: <LinkIcon sx={{ color: 'warning.main' }}></LinkIcon>,
        link: '/org/links'
      },
      {
        primary: 'ספר השלוחים',
        icon: <GroupsIcon />,
        link: '/org/shluchim-book'
      },
      { primary: 'צא״ח דרייב', icon: <CloudQueue />, link: '/org/archive' },
      {
        primary: 'טפסים ושאלונים',
        icon: <Assignment />,
        link: '/org/forms'
      }
    ]
  },
  {
    primary: 'עזרי שליחות',
    mobileMenuSubtitle: 'הלוח, בדיקות סתם, מבצע חינוך, כוחות הבטחון, מענקים',
    icon: <Icon icon="folder" color="primary.main" size="medium" />,
    children: [
      {
        primary: 'הלוח',
        icon: <NewspaperOutlined sx={{ color: 'warning.main' }}></NewspaperOutlined>,
        link: '/tools/business-ads'
      },
      {
        primary: 'מערכת בדיקות סת"ם',
        icon: <DocumentScanner />,
        link: '/tools/stam-checks/system'
      },
      {
        primary: 'מבצע חינוך',
        icon: <CelebrationIcon />,
        link: '/tools/holidays-and-enjoyments'
      },
      {
        primary: 'כוחות הביטחון',
        icon: <Security />,
        link: '/tools/security-forces'
      },
      {
        primary: 'מבצע חינוך מענקים',
        icon: <VolunteerActivismIcon />,
        link: '/tools/education-grants'
      },
      {
        primary: 'מסך פרסום דיגיטלי',
        icon: <Icon icon="monitor" color="primary.main" size="medium" />,
        link: '/tools/digital-screen'
      }
    ]
  },
  {
    primary: 'ניהול',
    mobileMenuSubtitle: 'זיכוים, צור קשר, תקנונים ומדריכים',
    isAccountMenu: true,
    icon: <Icon icon="settings" color="primary.main" size="medium" />,
    children: [
      { primary: 'הפרופיל שלי', icon: <EditIcon />, link: '/system/shluchim/profile' },
      {
        primary: 'זיכוים חב"ד ישראל',
        icon: <TrendingUpIcon sx={{ color: theme.palette.primary.main }} />,
        link: '/org/finance'
      },
      {
        primary: 'בקשות ביצוע תשלום',
        icon: <RequestQuoteIcon sx={{ color: 'warning.main' }} />,
        link: '/org/donation-refund-requests'
      },
      { primary: 'צור קשר', icon: <WhatsAppIcon />, menuAction: 'contact' },
      { primary: 'תקנונים ומדריכים — ישראל', icon: <MenuBookOutlinedIcon />, link: ISRAEL_REGULATIONS_ROUTE },
      { primary: 'תקנונים ומדריכים — חו״ל', icon: <MenuBookOutlinedIcon />, link: WORLD_REGULATIONS_ROUTE },
      { primary: 'יציאה מהמערכת', icon: <LogoutIcon />, menuAction: 'logout' }
    ]
  },
  {
    primary: 'ניהול מערכת',
    mobileMenuSubtitle: 'שלוחים, סניפים, תשלומים, מנויים, דוחות שימוש',
    icon: <Icon icon="powerButton" color="primary.main" size="medium" />,
    children: [
      { primary: 'משתמשים', icon: <PeopleIcon />, link: '/system/users' },
      { primary: 'שלוחים', icon: <PeopleIcon />, link: '/system/shluchim' },
      { primary: 'השוואת קבוצה לקובץ', icon: <LocalOfferIcon />, link: '/system/shluchim/group-compare' },
      { primary: 'סניפים', icon: <BusinessIcon />, link: '/system/branches' },
      { primary: 'תגיות', icon: <LocalOfferIcon />, link: '/system/tags' },
      { primary: 'שיתוף חשבונות', icon: <PeopleIcon />, link: '/system/members' },
      { primary: 'תשלומים', icon: <Payment />, link: '/system/payments' },
      { primary: 'מנויים', icon: <CardMembershipIcon />, link: '/system/subscriptions' },
      { primary: 'דוחות שימוש', icon: <SmsIcon />, link: '/system/crm-sms-usage' },
      { primary: 'שימוש AI - קדמה', icon: <Ai />, link: '/system/ai-usage' },
      { primary: 'וובהוקים', icon: <LinkIcon />, link: '/system/webhooks' }
    ]
  }
];

export enum FileType {
  'folder' = 'folder',
  'pdf' = 'pdf',
  'image' = 'image',
  'video' = 'video',
  'audio' = 'audio',
  'html' = 'html',
  'wa' = 'wa',
  'link' = 'link',
  'doc' = 'doc',
  'excel' = 'excel',
  'ppt' = 'ppt',
  'kedma' = 'kedma',
  'images' = 'images',
  'eventTemplate' = 'eventTemplate',
  'folderUpload' = 'folderUpload',
  'fileUpload' = 'fileUpload'
}

export const speedDialActions = [
  {
    icon: <FolderOpenOutlined color="secondary" />,
    tooltipTitle: 'הוסף תיקייה',
    dialogType: FileType.folder
  },
  {
    icon: <PictureAsPdfIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ PDF',
    dialogType: FileType.pdf
  },
  {
    icon: <ImageOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ תמונה',
    dialogType: FileType.image
  },
  {
    icon: <OndemandVideoOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ וידיאו',
    dialogType: FileType.video
  },
  {
    icon: <AudioFileOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ שמע',
    dialogType: FileType.audio
  },
  {
    icon: <HtmlOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ תוכן עשיר',
    dialogType: FileType.html
  },
  {
    icon: <InsertLinkOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קישור',
    dialogType: FileType.link
  },
  {
    icon: <WhatsAppIcon color="secondary" />,
    tooltipTitle: 'הוסף פרסום לאווטסאפ',
    dialogType: FileType.wa
  },
  {
    icon: <BlurCircularIcon color="secondary" />,
    tooltipTitle: 'הוסף עיצוב קדמה',
    dialogType: FileType.kedma
  },
  {
    icon: <ImageOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף תמונה',
    dialogType: FileType.images
  },
  {
    icon: <EventIcon color="secondary" />,
    tooltipTitle: 'יצירת תבנית אירוע',
    dialogType: FileType.eventTemplate
  }
];

export const fileArchiveOnlySpeedDialActions = [
  {
    icon: <DriveFolderUploadOutlined color="secondary" />,
    tooltipTitle: 'העלה תיקייה',
    dialogType: FileType.folderUpload
  },
  {
    icon: <UploadFile color="secondary" />,
    tooltipTitle: 'העלה קובץ',
    dialogType: FileType.fileUpload
  }
];

export const phonePrefix = [
  { code: '050' },
  { code: '051' },
  { code: '052' },
  { code: '053' },
  { code: '054' },
  { code: '055' },
  { code: '057' },
  { code: '058' },
  { code: '08' },
  { code: '03' },
  { code: '02' },
  { code: '04' },
  { code: '01' },
  { code: '09' }
];

export enum DepartmentEnum {
  TZACH = 'צעירי אגודת חב״ד',
  EZREI_SHLICHUT = 'המרכז לעזרי שליחות',
  LEYL_SHISHI = 'ליל שישי לשלוחים',
  EZREI_SHLUCHOT = 'המרכז לעזרי שלוחות',
  SNIFIM = 'אגף הסניפים',
  MIVTZA_CHINUCH = 'אגף מבצע חינוך',
  TERROR_VICTIMS = 'אגף נפגעי טרור',
  SECURITY_FORCES = 'אגף כוחות הביטחון',
  SPOKESMAN = 'אגף הדוברות',
  MIVTZA_TORAH = 'אגף מבצע תורה'
}

export const departmentOptions = Object.values(DepartmentEnum).map(department => ({
  value: department,
  label: department
}));

// Shared select options used across the app (copied exactly from form usages)
export const merchavOptions = [
  { value: 'עיר', label: 'עיר' },
  { value: 'עיר קטנה', label: 'עיר קטנה' },
  { value: 'ישוב', label: 'ישוב' },
  { value: 'מועצה מקומית', label: 'מועצה מקומית' },
  { value: 'מושב/קהילתי', label: 'מושב/קהילתי' },
  { value: 'שכונה', label: 'שכונה' },
  { value: 'אזורי', label: 'אזורי' },
  { value: 'קמפוס', label: 'קמפוס' },
  { value: 'בית רפואה', label: 'בית רפואה' },
  { value: 'דוכן', label: 'דוכן' },
  { value: 'מוסד חינוכי', label: 'מוסד חינוכי' },
  { value: 'מסחר/תעשיה', label: 'מסחר/תעשיה' },
  { value: 'עמדה', label: 'עמדה' },
  { value: 'כלא', label: 'כלא' },
  { value: 'נוער', label: 'נוער' }
];

export const userTypeOptions = [
  { value: 'שליח', label: 'שליח' },
  { value: 'שליחה', label: 'שליחה' },
  { value: 'שליח צעיר', label: 'שליח צעיר' },
  { value: 'שליחה צעירה', label: 'שליחה צעירה' },
  { value: 'עובד בית חב"ד', label: 'עובד בית חב"ד' },
  { value: 'מנהל סניף - חב"ד', label: 'מנהל סניף - חב"ד' },
  { value: 'מנהלת סניף - חב"ד', label: 'מנהלת סניף - חב"ד' },
  { value: 'פעיל אנ"ש', label: 'פעיל אנ"ש' },
  { value: worldShalich, label: worldShalich },
  { value: worldShalicha, label: worldShalicha },
  { value: publicUserType, label: publicUserType },
  { value: publicAdminUserType, label: publicAdminUserType },
  { value: 'מנכ"ל סניף', label: 'מנכ"ל סניף' },
  { value: 'תורם', label: 'תורם' },
  { value: 'אח"מ', label: 'אח"מ' }
];

export const roleOptions = [
  { value: 'מנהל מערכת- אגף הסניפים', label: 'מנהל מערכת- אגף הסניפים' },
  { value: 'מנהל מערכת', label: 'מנהל מערכת' },
  { value: 'יו"ר סניף', label: 'יו"ר סניף' },
  { value: 'מנהל סניף', label: 'מנהל סניף' },
  { value: 'מנהל תת סניף', label: 'מנהל תת סניף' },
  { value: 'סגן מנהל סניף', label: 'סגן מנהל סניף' },
  { value: 'מנהל פעילות', label: 'מנהל פעילות' },
  { value: 'פעילות', label: 'פעילות' },
  { value: 'משרד', label: 'משרד' },
  { value: 'מנהל פעילות', label: 'מנהל פעילות' },
  { value: 'מוסד/מחלקה/תחום', label: 'מוסד/מחלקה/תחום' }
];

export const statusOptions = [
  { value: 'מאושר', label: 'מאושר' },
  { value: 'ממתין לאישור', label: 'ממתין לאישור' },
  { value: 'ממתין לעדכון פרטים', label: 'ממתין לעדכון פרטים' },
  { value: 'מועמד לשליחות', label: 'מועמד לשליחות' },
  { value: 'שליח בבירור', label: 'שליח בבירור' },
  { value: 'שליח מושעה', label: 'שליח מושעה' },
  { value: 'מבוטל', label: 'מבוטל' },
  { value: 'נפטר/ה', label: 'נפטר/ה' },
  { value: 'שליחות הסתיימה', label: 'שליחות הסתיימה' }
];

export const creditInTheMLSOptions = [
  { value: false, label: 'במל"ש' },
  { value: true, label: 'העברה בנקאית חודשית לחשבון העמותה' }
];

export const formTypeOptions = [
  { value: 'הגשת בקשה', label: 'הגשת בקשה' },
  { value: 'סקר', label: 'סקר' },
  { value: 'שאלון', label: 'שאלון' },
  { value: 'הגשת מסמכים', label: 'הגשת מסמכים' },
  { value: 'הרשמה', label: 'הרשמה' },
  { value: 'מנוי', label: 'מנוי' },
  { value: 'דיווח', label: 'דיווח' },
  { value: 'אחר', label: 'אחר' }
];

// There is a doc in mongoDB with the default fields for the form
export const defaultFormFields: PredefinedSection & { source: string } = {
  value: 'default',
  label: 'פרטים אישיים קבועים',
  source: 'Shluchim',
  fields: [
    { name: 'name', type: 'string', label: 'שם השליח' },
    { name: 'phone', type: 'number', label: 'מספר טלפון' },
    { name: 'location', type: 'string', label: 'מקום השליחות' },
    { name: 'malashId', type: 'number', label: 'מספר במלש' }
  ]
};

export const formResultStatusColor: Record<FormResultsStatuses[number], ChipProps['color']> = {
  חדש: 'default',
  בתהליך: 'warning',
  בטיפול: 'warning',
  מעוכב: 'error',
  נדחה: 'error',
  מבוטל: 'error',
  מאושר: 'success',
  'נדרש דוח': 'warning',
  הסתיים: 'success',
  עדכון: 'info'
};

export type DetailsSections =
  | 'ShaliachForm'
  | 'ShaliachFormPublic'
  | 'BranchForm'
  | 'BranchFormPublic'
  | 'JudikaForm'
  | 'BetKnesetForm';

export const businessAdsSelects = [
  { name: 'category', label: 'קטגוריה' },
  { name: 'subcategory', label: 'תת קטגוריה' }
];

export const dependentOptions: DependentOption[] = [
  {
    value: 'שיעורים והרצאות',
    label: 'שיעורים והרצאות',
    children: [
      { value: 'הרצאות', label: 'הרצאות' },
      { value: 'שיעורים', label: 'שיעורים' },
      { value: 'קורסים', label: 'קורסים' },
      { value: 'מרצים להתוועדויות', label: 'מרצים להתוועדויות' },
      { value: 'סיורים לימודיים', label: 'סיורים לימודיים' },
      { value: 'טיולים וסיורים לקבוצות', label: 'טיולים וסיורים לקבוצות' }
    ]
  },
  {
    value: 'מופעים והפעלות',
    label: 'מופעים והפעלות',
    children: [
      { value: 'סדנאות', label: 'סדנאות' },
      { value: 'הפעלות', label: 'הפעלות' },
      { value: 'מופעים', label: 'מופעים' },
      { value: 'מוזיקאים', label: 'מוזיקאים' },
      { value: 'משחקי למידה וחברה', label: 'משחקי למידה וחברה' }
    ]
  },
  {
    value: 'שיווק, פרסום ומיתוג',
    label: 'שיווק, פרסום ומיתוג',
    children: [
      { value: 'שיווק דיגיטלי', label: 'שיווק דיגיטלי' },
      { value: 'ניהול מדיה', label: 'ניהול מדיה' },
      { value: 'כתיבה ועריכת תוכן', label: 'כתיבה ועריכת תוכן' },
      { value: 'עיצוב גרפי (פליירים, לוגואים)', label: 'עיצוב גרפי (פליירים, לוגואים)' },
      { value: 'צילום ועריכת וידאו', label: 'צילום ועריכת וידאו' },
      { value: 'הדפסה', label: 'הדפסה' },
      { value: 'שילוט', label: 'שילוט' }
    ]
  },
  {
    value: 'ניהול פיננסי ועסקי',
    label: 'ניהול פיננסי ועסקי',
    children: [
      { value: 'הנהלת חשבונות', label: 'הנהלת חשבונות' },
      { value: 'ראיית חשבון', label: 'ראיית חשבון' },
      { value: 'ייעוץ פיננסי ועסקי', label: 'ייעוץ פיננסי ועסקי' },
      { value: 'ייעוץ מס', label: 'ייעוץ מס' },
      { value: 'גיוס כספים', label: 'גיוס כספים' },
      { value: 'פיתוח עסקי וארגוני', label: 'פיתוח עסקי וארגוני' },
      { value: 'תכנון תקציבים', label: 'תכנון תקציבים' },
      { value: 'ייעוץ משפטי ועריכת דין', label: 'ייעוץ משפטי ועריכת דין' },
      {
        value: 'שירותי מזכירות (ניהול יומן, עוזר אישי, טלפניות)',
        label: 'שירותי מזכירות (ניהול יומן, עוזר אישי, טלפניות)'
      }
    ]
  },
  {
    value: 'לוגיסטיקה ותפעול',
    label: 'לוגיסטיקה ותפעול',
    children: [
      { value: 'משלוחים והסעות', label: 'משלוחים והסעות' },
      { value: 'תחזוקת מבנים', label: 'תחזוקת מבנים' },
      { value: 'ציוד', label: 'ציוד' },
      { value: 'שירותי ניקיון', label: 'שירותי ניקיון' }
    ]
  },
  {
    value: 'ריהוט וציוד מוסדי',
    label: 'ריהוט וציוד מוסדי',
    children: [
      { value: 'ריהוט לבתי כנסת', label: 'ריהוט לבתי כנסת' },
      { value: 'ריהוט לגנים ובתי ספר', label: 'ריהוט לגנים ובתי ספר' },
      { value: 'ציוד לגנים וקייטנות', label: 'ציוד לגנים וקייטנות' },
      { value: 'ספרי קודש וספריות', label: 'ספרי קודש וספריות' }
    ]
  },
  {
    value: 'הפקת אירועים וציוד',
    label: 'הפקת אירועים וציוד',
    children: [
      { value: 'הפקה וניהול אירועים', label: 'הפקה וניהול אירועים' },
      { value: 'הנחיית אירועים', label: 'הנחיית אירועים' },
      { value: 'ציוד הגברה ותאורה', label: 'ציוד הגברה ותאורה' },
      { value: 'מסכים ואביזרים ויזואליים', label: 'מסכים ואביזרים ויזואליים' },
      { value: 'מחיצות ושילוט', label: 'מחיצות ושילוט' },
      { value: 'השכרת ריהוט (שולחנות, כיסאות)', label: 'השכרת ריהוט (שולחנות, כיסאות)' },
      { value: 'אבטחה ושמירה', label: 'אבטחה ושמירה' },
      { value: 'דוכנים ופופ-אפים', label: 'דוכנים ופופ-אפים' },
      { value: 'ציוד טכני (מקרנים, מיקרופונים)', label: 'ציוד טכני (מקרנים, מיקרופונים)' },
      { value: 'עיצוב חלל ובמות', label: 'עיצוב חלל ובמות' }
    ]
  },
  {
    value: 'קייטרינג',
    label: 'קייטרינג',
    children: [
      { value: 'קייטרינג חלבי', label: 'קייטרינג חלבי' },
      { value: 'קייטרינג בשרי', label: 'קייטרינג בשרי' },
      { value: 'מגשי אירוח', label: 'מגשי אירוח' },
      { value: 'מאפים וקינוחים', label: 'מאפים וקינוחים' }
    ]
  }
];

export const WHATSAPP_TEMPLATES = '/api/pvt/whatsapp/templates';
export const WHATSAPP_TEMPLATES_STATUS = '/api/pvt/whatsapp/templates/status';

// Holidays and Enjoyments Landing Page
export const HOLIDAYS_AND_ENJOYMENTS_LANDING_URL = '/pub/holidays-and-enjoyments';
export const HOLIDAYS_AND_ENJOYMENTS_SIGNED_DOCUMENTS_FOLDER = 'holidays-and-enjoyments-signed-documents';

// Security Forces
export const securityForcesMessengerCardUrl = 'pvt/security-forces/messenger-card';
export const securityForcesGrantRequestsUrl = 'pvt/security-forces/grant-requests';
export const securityForcesGrantSubmissionsUrl = 'pvt/security-forces/grant-submissions';
export const securityForcesManagerActivityLocationsUrl = 'pvt/security-forces/manager/activity-locations';
export const securityForcesManagerSubmissionsUrl = 'pvt/security-forces/manager/submissions';
export const securityForcesManagerSubmissionsBulkUpdateUrl = 'pvt/security-forces/manager/submissions/bulk-update';
export const securityForcesManagerSubmissionsBulkDeleteUrl = 'pvt/security-forces/manager/submissions/bulk-delete';
export const securityForcesManagerMessengersNotSubmittedUrl = 'pvt/security-forces/manager/messengers-not-submitted';
export const securityForcesDashboardUrl = 'pvt/security-forces/dashboard';

// Education Grants (מבצע חינוך מענקים)
export const educationGrantsMessengerCardUrl = 'pvt/education-grants/messenger-card';
export const educationGrantsGrantRequestsUrl = 'pvt/education-grants/grant-requests';
export const educationGrantsGrantSubmissionsUrl = 'pvt/education-grants/grant-submissions';
export const educationGrantsManagerInstitutionsUrl = 'pvt/education-grants/manager/institutions';
export const educationGrantsManagerSubmissionsUrl = 'pvt/education-grants/manager/submissions';
export const educationGrantsManagerSubmissionsBulkUpdateUrl = 'pvt/education-grants/manager/submissions/bulk-update';
export const educationGrantsManagerSubmissionsBulkDeleteUrl = 'pvt/education-grants/manager/submissions/bulk-delete';
export const educationGrantsManagerMessengersNotSubmittedUrl = 'pvt/education-grants/manager/messengers-not-submitted';
export const educationGrantsDashboardUrl = 'pvt/education-grants/dashboard';

// Branch Website (האתר שלי / חב״ד ישראל)
export const branchWebsiteUrl = 'pvt/branch-website';
export const branchWebsiteListUrl = 'pvt/branch-website/list';

// NanoSite SSO
export const nanositeSsoUrl = 'pvt/nanosite/sso-url';

// System Members (חברי מערכת)
export const systemMembersUrl = 'pvt/system-members';

// Shluchim Employees (עובדי בית חב"ד)
export const shluchimEmployeesUrl = 'pvt/shluchim/employees';

export const webhooksUrl = 'pvt/webhooks';

// CRM SMS Usage (דוח שימוש SMS)
export const crmSmsUsageUrl = 'pvt/crm/sms-usage';

// Venues (מקומות אירוע)
export const venuesUrl = 'pvt/venues';

// Event series (סדרות אירוע)
export const eventSeriesUrl = 'pvt/event-series';

// Meals (סעודות במופע אירוע)
export const mealsUrl = 'pvt/meals';

export const PERSONAL_PAGE_DEPARTMENTS = ['טפסים באתר', 'דפים אישיים', 'אירועים', 'קמפיינים'];

export const CONTACT_US_NUMBER = '972515415770';

export const WAZE_COLOR = '#15CCFF';

// Digital Screen (מסך פרסום דיגיטלי)
export const digitalScreenScreensUrl = 'pvt/digital-screen/screens';
export const digitalScreenAdminAssetsUrl = 'pvt/digital-screen/admin-assets';
export const digitalScreenAssetsUrl = (screenId: string) => `pvt/digital-screen/screens/${screenId}/assets`;
export const digitalScreenReorderUrl = (screenId: string) => `pvt/digital-screen/screens/${screenId}/assets/reorder`;
export const digitalScreenAdminReorderUrl = 'pvt/digital-screen/admin-assets/reorder';
export const digitalScreenCustomWindowsUrl = (screenId: string) =>
  `pvt/digital-screen/screens/${screenId}/custom-windows`;
